<template>

  <t-page>

    <ChecklistDialog @onSubmit="onChecklistDialog" :schedule="modalChecklistSchedule"/>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">

      <template #search>

        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">

          <t-input-search v-model="form.startDate" date label="Data inicial"/>

          <t-input-code-label enterprise
                              v-model="form.enterpriseId"/>

          <t-input-code-label inspector
                              v-model="form.inspectorId"/>


          <t-input-search v-model="form.statusSchedule" :options="ScheduleStatusType.list" checkbox label="Status Agenda"/>


        </t-content-header-search-default>

      </template>


      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               primary-key-column="scheduleNumber" link-primary-column="startDate">

        <template #item(statusSchedule)="{item}">

          <b-badge v-if="item.statusSchedule === ScheduleStatusType.type.PENDING"
                   variant="warning">Pendente
          </b-badge>

          <b-badge v-else-if="item.statusSchedule === ScheduleStatusType.type.IN_PROGRESS"
                   variant="info">Andamento
            <t-help :title="getPendingText(item)"/>
          </b-badge>


          <b-badge v-else-if="item.statusSchedule === ScheduleStatusType.type.LATE"
                   variant="danger">Atrasada
          </b-badge>
          <b-badge v-else-if="item.statusSchedule === ScheduleStatusType.type.DONE"
                   variant="success">Realizada
          </b-badge>

        </template>

        <template #append-actions="{item}">
          <t-button class="mr-2" v-if="item.statusSchedule !== ScheduleStatusType.type.DONE" text="Realizar"
                    @click="openModalChecklist(item)"/>
        </template>


      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import ScheduleStatusType from "@/model/types/modules/checklist/ScheduleStatusType";
import ChecklistDialog from "@/views/modules/checklist/Checklist/ChecklistDialog";
import ui from "@/assets/scripts/ui";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'Schedule',
  components: {ChecklistDialog},
  data() {
    return {
      ScheduleStatusType,
      enableGeneralFields: false,
      form: {
        startDate: "",
        enterpriseId:0,
        inspectorId:0,
        statusSchedule:[ScheduleStatusType.type.PENDING,ScheduleStatusType.type.IN_PROGRESS,ScheduleStatusType.type.LATE],
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modalChecklistSchedule: {},
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      //Remove busca por status do padrão, pois nesta tela não há status
      delete this.form.status

      this.setIsLoadingPage(true)

      this.breadcrumb = [
        //{text: 'Configurações', to: {name: 'production-setting'}},
      ]

    },
    async mountedContinued() {

      this.searchDefault()

      this.setIsLoadingPage(false)

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openModalChecklist(item) {

      if (item.pendingInspectorId !== undefined && item.pendingInspectorId > 0) {
        ui.msgConfirm(this, '','Tem certeza que deseja iniciar novamente este checklist?<br />Caso continuar poderá gerar uma duplicidade, além disso a informação do checklist em andamento será sobreposta pela última inclusão.', () => {
          this.modalChecklistSchedule = item
          this.openDialogForm('modal-checklist')
        })
      } else {
        this.modalChecklistSchedule = item
        this.openDialogForm('modal-checklist')
      }


    },
    onChecklistDialog(itemInserted) {
      this.goPath('checklist/' + itemInserted.value)
    },
    getPendingText(item) {

      return 'Iniciado por:<br /><b>' + item.pendingInspector + "</b><br />" + ui.convertDateBR(item.pendingStarted, true)

    }
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>

